import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line', 
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },
    {
        id: 5,
        label: 'MENUITEMS.LOCATION.TEXT',
        icon: 'ri-map-pin-line',
        link: '/locations'
    },
    {
        id: 8,
        label: 'MENUITEMS.ACTIVATION.TEXT',
        icon: 'ri-toggle-line',
        link: '/activations'
    },
    {
        id: 9,
        label: 'MENUITEMS.BOARDREAD.TEXT',
        icon: 'ri-file-text-line',
        link: '/boardReads'
    },
    {
        id: 10,
        label: 'MENUITEMS.COLLECTIONSUMMARY.TEXT',
        icon: 'ri-bar-chart-line',
        link: '/collectionSummary'
    },
    {
        id: 11,
        label: 'Konnect Live Reads',
        icon: 'ri-flashlight-line',
        link: '/fusion-connect'
    },
    {
        id: 12,
        label: 'Konnect Live Stats',
        icon: 'ri-line-chart-line',
        link: '/fusion-connect-stats'
    },
];